import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { trackRouteChange } from '@/utility/analytics';

const RouteTracker = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (route) => {
      //Clean up Framer page's content and style when the redirection happens
      if (
        typeof document !== 'undefined' &&
        document.getElementById('main')
      ) {
        // to clean up content on Framer
        // document.getElementById('main').remove();
        // document
        //   .getElementById('navbar-element')
        //   ?.style?.removeProperty('position');

        window.location.href = window.location.origin + route;
        return;
      }

      // eslint-disable-next-line no-console
      console.log('Tracking route change:', route);
      trackRouteChange(route);
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default RouteTracker;
